<iframe name="print_frame" id="print_frame" width="100%" height="100%" frameBorder="0" [src]="urlSafe"></iframe>
